<template >
  <div class="new-home-service">
    <h2>Testachats, à votre service</h2>

    <div class="icons">
      <div class="icon-container" style="margin: 0 10px 0 0;">
        <img src="/images/fr_new_home/60ans.png" alt="" style="margin-bottom: 6px;" width="120px" height="90px" class="mobile_hide"/>
        <img src="/images/fr_new_home/Atom/60ans-m.png" alt="" style="margin-bottom: 6px;" width="56px" height="90px" class="desktop_hide"/>
        <p class="text-uppercase">d'expertise</p>
      </div>
      <div class="icon-container association">
        <img src="/images/fr_new_home/Atom/Icon/trust-association.png" style="height: 84px" alt="" width="92px" height="84px" />
        <p class="text-uppercase">association de consommateurs <br> en Belgique</p>
      </div>
      <div class="icon-container independant" style="margin: 0 0 0 4px;">
        <img src="/images/fr_new_home/Atom/Icon/LIST/trust-independant.png"  alt="" width="59" height="59"  />
        <h3 style="margin-top: 2px;">Indépendant</h3>
        <p class="text-uppercase">de tout lobby et <br class="mobile_hide">de toute enseigne</p>
      </div>
    </div>

    <p class="description">
      Testachats est une association qui a pour objectif d'informer, de
      défendre et de représenter les consommateurs en Belgique. Nous sommes
      <strong>indépendants</strong> de toute influence politique ou économique.
      C’est pourquoi notre abonnement vous donne
      <strong>un pack d’avantages membres</strong>
      vous permettant de faire
      <strong
        >des économies, de vous protéger et d’en apprendre plus sur des sujets
        variés.</strong
      >
    </p>
    <img class="open-box" :src="service_image" alt="" />
    <img class="open-box-m" :src="service_image_mobile" alt="" />
  </div>
</template>
<script>
import image_mixin from "../mixins/image_mixin";

export default {
    mixins:[image_mixin]
};
</script>
